import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  MediaViewModel,
  SectionViewModel,
} from "src/domain/client";
import { MediaPipe } from "src/pipes/media.pipe";

@Component({
  selector: "vw-link-block",
  templateUrl: "./link-block.component.html",
})
export class LinkBlockComponent implements OnInit {
  @Input({ required: true }) linkBlock!: SectionViewModel;
  @ViewChild("videoPlayer", { static: false }) videoplayer?: ElementRef;
  caption?: string;
  body?: string;
  theme?: string;
  linkType?: string;
  link?: string;
  media?: string;
  mediaType?: string;

  constructor(private mediaPipe: MediaPipe) {}

  ngOnInit(): void {
    const media: MediaViewModel[] = this.linkBlock.media
      ? [...this.linkBlock.media]
      : [];
    this.caption = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Caption,
      MediaTypeNameEnum.Text,
    );
    this.body = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Body,
      MediaTypeNameEnum.Text,
    );
    this.theme = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Technical,
      MediaTypeNameEnum.Text,
    );
    this.linkType = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Technical,
      MediaTypeNameEnum.Button,
    );
    this.link = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.HREF,
      MediaTypeNameEnum.Link,
    );
    this.media = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Technical,
      MediaTypeNameEnum.Link,
    );
    this.mediaType = this.mediaPipe.transform(
      media,
      MediaCategoryTypeNameEnum.Technical,
      MediaTypeNameEnum.Video,
    );
  }

  public playVideo(): void {
    this.videoplayer?.nativeElement.play();
  }
}
